import React, { useState, useMemo } from 'react';
import urls from '../../constants';
import { NotFound } from '../../components/common/NotFound';
import PaginationComponent from '../common/PaginationComponent';
import UserMasterWorklistRow from './UserMasterWorklistRow';
import UserMasterSkeletonRow from './UserMasterSkeletonRow';

const UserMasterGrid = (props) => {
    const { filteredResults, handleEdit, handleDelete,
        handleView, loading, menuRights,
        moduleName, handleResetPassword } = props

    const userProfile = JSON.parse(localStorage.getItem("userProfile"));
    const isAdmin = userProfile?.roleId === urls.ADMIN_ROLE_ID;

    const [count, setCount] = useState(25);
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = count;

    const currentTableData = useMemo(() => {
        if (filteredResults?.length <= pageSize) setCurrentPage(1);
        else if (currentPage > Math.ceil(filteredResults?.length / pageSize)) {
            setCurrentPage(1)
        }

        const firstPageIndex = (currentPage - 1) * pageSize;
        const lastPageIndex = firstPageIndex + pageSize;
        return filteredResults?.slice(firstPageIndex, lastPageIndex);
    }, [currentPage, filteredResults, count]);

    const showData = currentTableData?.length > 0;
    const showSkeleton = loading === true && !showData;
    const showNotFound = loading !== true && !showData;

    return (
        <>
            {(showData || showSkeleton) && (
                <div className="row table-row user-table-row mb-4rem">
                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div className="quote-worklist-header user-worklist-header">
                            <div>User</div>
                            <div>Company / Distributor</div>
                            <div>User Type</div>
                            <div>Role</div>
                            <div>Status</div>
                            <div></div>
                        </div>
                        {showData &&
                            currentTableData.map((items, index) => (
                                <UserMasterWorklistRow
                                    key={items?.id}
                                    item={items}
                                    rowIndex={index}
                                    isAdmin={isAdmin}
                                    menuRights={menuRights}
                                    handleView={handleView}
                                    handleEdit={handleEdit}
                                    handleResetPassword={handleResetPassword}
                                />
                            ))}
                        {showSkeleton &&
                            Array.from({ length: 10 }).map((_, index) => (
                                <UserMasterSkeletonRow key={index} rowIndex={index} />
                            ))}
                    </div>
                </div>
            )}
            {showNotFound && <NotFound />}
            {showData && (
                <PaginationComponent
                    count={count}
                    setCount={setCount}
                    pageSize={pageSize}
                    currentPage={currentPage}
                    filteredResults={filteredResults}
                    setCurrentPage={setCurrentPage} />
            )}
        </>
    )
}

export default React.memo(UserMasterGrid)